import React from 'react'

export default function Hero() {
	return (
		<section
			className="w-full min-h-screen pt-20 md:pt-32 rounded-b-2xl border border-gray-200 md:pb-16 overflow-hidden"
			style={{
				background:
					'linear-gradient(180deg, #f0f7ff 0%, #dbeafe 30%, #bfdbfe 60%, #93c5fd 85%, #60a5fa 100%)',
			}}
		>
			<div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl w-full">
				<div className="text-center ">
					<p className="inline-block text-sm sm:text-base font-medium mb-6 bg-gray-50 text-gray-800 px-4 py-2 rounded-full border border-gray-200">
						<span className="text-blue-600">Built for Amazon Relay US</span>
					</p>

					<h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold mb-6 sm:mb-8 leading-none tracking-tight text-gray-600">
						<span className="block mb-2">
							<span className="block sm:inline">Finally, a </span>
							<span
								className="relative inline-block font-extrabold"
								style={{
									background:
										'linear-gradient(to right, #1e3a8a 0%, #1e40af 20%, #2463eb 40%, #2563eb 60%, #3b82f6 80%, #2463eb 100%)',
									WebkitBackgroundClip: 'text',
									WebkitTextFillColor: 'transparent',
									backgroundClip: 'text',
									letterSpacing: '-0.02em',
								}}
							>
								Better Way
							</span>
							<span className="block">to do Relay Amazon</span>
						</span>{' '}
					</h1>

					<p className="text-lg sm:text-xl md:text-2xl text-gray-700 font-semibold mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed tracking-wide px-4 sm:px-0">
						Manage your entire Relay operation – from load booking
						<br />
						to on-time tracking to finances. Works out of the box.
					</p>

					<a
						href="https://chromewebstore.google.com/u/1/detail/relay-auto-refresher-post/ihcgicdogclbieclnldfjmlglkolankb?hl=en"
						target="_blank"
						rel="noopener noreferrer"
						className="inline-block text-white hover:opacity-90 rounded-full px-8 sm:px-10 py-3 sm:py-4 text-base sm:text-xl font-bold shadow-xl transition-all transform hover:scale-105 tracking-wide"
						style={{
							background:
								'linear-gradient(135deg, #2463eb 0%, #1d4ed8 50%, #1e40af 100%)',
							boxShadow: '0 10px 25px rgba(36, 99, 235, 0.3)',
						}}
					>
						Get Started for Free
					</a>

					<div className="flex items-center justify-center mt-8 sm:mt-10 max-w-5xl mx-auto px-4 sm:px-0">
						<div className="flex-1 h-px bg-gray-400 hidden sm:block"></div>
						<p className="text-sm sm:text-base text-gray-700 font-medium mx-4 sm:mx-6 text-center sm:whitespace-nowrap">
							<span className="block sm:inline">
								Trusted by{' '}
								<span className="font-bold text-blue-600">
									18,000+ logistics professionals
								</span>
							</span>{' '}
							<span className="block sm:inline">
								to streamline their Amazon Relay operations daily.
							</span>
						</p>
						<div className="flex-1 h-px bg-gray-400 hidden sm:block"></div>
					</div>
				</div>
			</div>
		</section>
	)
}
